module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.infos.options.length > 1) ? _c('button-dropdown', {
    attrs: {
      "infos": _vm.infos,
      "defaultOption": _vm.listInitial
    },
    on: {
      "change": _vm.changeList
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40148a4a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/TypeList.vue
// module id = 3086
// module chunks = 0